import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { CalendarScreenState } from './types';

export const createCalendarScreenState: AppStateSlice<CalendarScreenState> = (
  set
) => ({
  calendar: {
    display_mode: 'month',
    active_date_string: new Date().toISOString(),

    setActiveDate(date) {
      set((state) => {
        state.calendar.active_date_string = date;
      });
    },

    setDisplayMode(mode) {
      set((state) => {
        state.calendar.display_mode = mode;
      });
    },

    setFilteredUserIDs(ids) {
      set((state) => {
        state.calendar.filtered_user_ids = ids;
      });
    },
  },
});
